import { Building2, Layers, FileText, Globe } from "lucide-react";
const features = [{
  icon: Building2,
  title: "Residential Property Income",
  description: "AurØra focuses on professionally managed residential property in established markets, supported by long term rental demand. The emphasis is on income durability and operational predictability rather than speculative outcomes."
}, {
  icon: Layers,
  title: "Tokenised Participation",
  description: "Participation is delivered through a tokenised structure that represents contractual income rights, not property ownership. This removes the need for mortgages, direct ownership, and ongoing administration."
}, {
  icon: FileText,
  title: "Structured Income Rights",
  description: "Tokens represent contractual income rights linked to underlying residential assets. They do not provide ownership or control, but offer a standardised way to track and receive income allocations."
}, {
  icon: Globe,
  title: "Global Platform Access",
  description: "AurØra is accessible internationally through a digital platform designed for transparency and account management. The platform operates continuously, allowing users to view portfolio information and reporting at any time."
}];
const WhyAurora = () => {
  return <section id="why-aurora" className="pt-3 lg:pt-6 lg:pb-32 relative pb-[10px] sm:pt-[10px] scroll-mt-20 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-full">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h3 className="text-lg md:text-xl font-normal mb-4 text-foreground">
            The AurØra Approach
          </h3>
          <p className="text-foreground/70 text-sm md:text-base leading-relaxed mb-4">
            AurØra applies on-chain infrastructure to property income, creating a new access layer between global capital and professionally managed assets.
          </p>
          <p className="text-foreground/70 text-sm md:text-base leading-relaxed">
            The result is faster access, clearer economics, and a structure designed to operate at scale. By removing legacy barriers, AurØra opens participation in property income to a broader audience that has historically been excluded by capital requirements, geography, or structural friction.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => <div key={feature.title} className="group p-6 rounded-xl bg-card border border-border/50 hover:border-primary/30 transition-all duration-300 animate-fade-up" style={{
          animationDelay: `${index * 0.1}s`
        }}>
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <feature.icon className="w-5 h-5 text-primary" />
              </div>
              <h4 className="font-medium text-sm mb-3 text-foreground">
                {feature.title}
              </h4>
              <p className="text-foreground/70 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default WhyAurora;